<div class="variants-container" >
  <div class="flex-box">
    <div class="heading">Regimen Given</div>
    <div class="flex gap-12">
      <button class="btn-primary-outline" *ngFor="let regimenClass of regimenClasses" (click)="onChangeRegimenClass(regimenClass)" [ngClass]="{'selected': selectedRegimenClass === regimenClass}">{{ regimenClass }}</button>
    </div>
  </div>
  <div class="flex gap-12">
    <ng-container *ngFor="let data of regimenData; let i = index;">
        <div class="variant-card-container col-xs-12">
          <div class="flex relative">
            <div class="totalSP">{{ data.price }} </div>
            <div class="noOfProducts">{{ data.noOfProducts }} products</div>
          </div>
          <div class="flex">
            <img src="/assets/images/new-tick.svg" alt="" class="icon">
            <p class="info">{{ data.products }}</p>
          </div>
        </div>
      </ng-container>
  </div>
</div>